import React from 'react';
import type { DashboardStats } from '../../models/DashboardStats';
import { HourlyHeatmap } from '../HourlyHeatmap';
import { UserRankingWidget } from '../UserRanking';

interface DashboardLayoutSAProps {
  data: DashboardStats;
}

export const DashboardLayoutSA: React.FC<DashboardLayoutSAProps> = ({
  data,
}) => (
  <>
    <div className='md:col-span-2 lg:col-span-2 min-h-[300px]'>
      <HourlyHeatmap data={data.heatmap} />
    </div>
    <div className='lg:col-span-1'>
      <UserRankingWidget data={data.usersRanking} />
    </div>
  </>
);
